"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUser = exports.UserProvider = exports.UserContext = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOCAL_STORE_JWT = "chim_jwt";

var initialState = { loggedin: false, user: {}, loaded: false };

var UserContext = _react2.default.createContext();

var reducer = function reducer(state, action) {
  console.log("action.type:", action.type);
  switch (action.type) {
    case "signin_open":
      return _extends({}, state, { loggedin: false, signin: true, signin_show_fav: false, loaded: true, isChim: false });
    case "signin_show_fav":
      return _extends({}, state, { loggedin: false, signin: true, signin_show_fav: true, loaded: true, isChim: false });
    case "signin_close":
      return _extends({}, state, { signin: false });
    case "logout":
      localStorage.removeItem(LOCAL_STORE_JWT);
      return _extends({}, initialState, { loggedin: false, signin: false, loaded: true, isChim: false });
    case "login":
      return _extends({}, state, { signin: false, loggedin: true, loaded: true, isChim: true, user: action.payload.user });
    case "user_login":
      // non-chim login
      return _extends({}, state, { signin: false, loggedin: true, loaded: true, isChim: false, user: action.payload.user });
    case "anonymous":
      return _extends({}, state, { signin: false, loggedin: false, loaded: true, isChim: false, user: {} });
    case "fail":
      return _extends({}, state, { signin: false, loggedin: false, loaded: true, isChim: false, user: {} });
    default:
      return _extends({}, state);
  }
};

function UserProvider(props) {
  var _React$useReducer = _react2.default.useReducer(reducer, initialState),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  var value = { state: state, dispatch: dispatch };
  return _react2.default.createElement(
    UserContext.Provider,
    { value: value },
    props.children
  );
}

function useUser() {
  var context = _react2.default.useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
}

exports.UserContext = UserContext;
exports.UserProvider = UserProvider;
exports.useUser = useUser;